'use client';
/* eslint-disable @typescript-eslint/no-explicit-any */
import { Button, Input } from '@leva/ui';
import { Eye, EyeOff } from 'lucide-react';
import { useRouter } from 'next/navigation';
import React, { useState, useTransition } from 'react';

import { GoogleSignInButton } from '@/components/google-sign-in-button';
import { trackMetaEvent } from '@/lib/meta-pixel/fbq';

export function RegisterForm() {
  const router = useRouter();
  const [email, setEmail] = useState('');
  const [name, setName] = useState('');
  const [password, setPassword] = useState('');
  const [showPassword, setShowPassword] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const [pending, startTransition] = useTransition();

  async function onSubmit(e: React.FormEvent) {
    e.preventDefault();
    setError(null);
    const res = await fetch('/api/auth/register', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ email, password, name }),
    });
    if (!res.ok) {
      const body = await res.json().catch(() => ({}));
      setError(body.error ?? 'Pendaftaran gagal');
      return;
    }
    trackMetaEvent('CompleteRegistration', { method: 'password' });
    startTransition(() => {
      router.push('/dashboard' as any);
      router.refresh();
    });
  }

  return (
    <form onSubmit={onSubmit} className="space-y-4">
      <div>
        <label className="block text-sm font-semibold text-brown mb-1.5" htmlFor="name">
          Nama
        </label>
        <Input
          id="name"
          autoComplete="name"
          required
          value={name}
          onChange={(e) => setName(e.target.value)}
        />
      </div>
      <div>
        <label className="block text-sm font-semibold text-brown mb-1.5" htmlFor="email">
          Email
        </label>
        <Input
          id="email"
          type="email"
          autoComplete="email"
          required
          value={email}
          onChange={(e) => setEmail(e.target.value)}
        />
      </div>
      <div>
        <label className="block text-sm font-semibold text-brown mb-1.5" htmlFor="password">
          Password
        </label>
        <div className="relative">
          <Input
            id="password"
            type={showPassword ? 'text' : 'password'}
            autoComplete="new-password"
            required
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            className="pr-10"
          />
          <button
            type="button"
            onClick={() => setShowPassword((v) => !v)}
            aria-label={showPassword ? 'Sembunyikan password' : 'Tampilkan password'}
            className="absolute right-3 top-1/2 -translate-y-1/2 text-brown-lt p-1 hover:text-brown-md transition-colors"
          >
            {showPassword ? (
              <EyeOff className="w-[18px] h-[18px]" />
            ) : (
              <Eye className="w-[18px] h-[18px]" />
            )}
          </button>
        </div>
        <p className="text-xs text-brown-lt mt-1">
          Minimal 8 karakter dengan huruf besar, huruf kecil, dan angka.
        </p>
      </div>
      {error && <p className="text-sm text-rose">{error}</p>}
      <Button type="submit" size="lg" className="w-full" disabled={pending}>
        {pending ? 'Membuat akun…' : 'Buat akun'}
      </Button>
      <div className="relative my-4">
        <div className="absolute inset-0 flex items-center">
          <div className="w-full border-t border-border" />
        </div>
        <div className="relative flex justify-center text-xs uppercase">
          <span className="bg-cream px-2 text-brown-md">atau</span>
        </div>
      </div>
      <GoogleSignInButton label="Daftar dengan Google" />
    </form>
  );
}
